import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import s from './range.module.scss';
export const Range = ({ min = 0, max = 100, step = 1, value = min, onChange, className, name }) => {
    return (_jsxs("div", { className: `${s.rangeContainer} ${className || ''}`, children: [_jsx("div", { className: s.inputContainer, children: _jsx("input", { type: "range", min: min, max: max, step: step, value: value, onChange: onChange, className: s.input, name: name }) }), _jsxs("output", { className: s.output, children: [value, "%"] })] }));
};
